export const AJAX_USERS_SELECT_PARAMS_MAP = {
  project_id: 'projectId',
  group_id: 'groupId',
  todo_filter: 'todoFilter',
  todo_state_filter: 'todoStateFilter',
  current_user: 'showCurrentUser',
  author_id: 'authorId',
  states: 'states',
};

export const ACTIVE_AND_BLOCKED_USER_STATES = ['active', 'blocked', 'ldap_blocked'];
